import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-45902ef4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container py-5" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"row justify-content-center\" data-v-45902ef4><div class=\"col-xl-8 col-lg-10 col-md-12\" data-v-45902ef4><div class=\"formation-card-new\" data-v-45902ef4><div class=\"formation-side\" data-v-45902ef4><i class=\"flaticon-education\" data-v-45902ef4></i></div><div class=\"formation-body\" data-v-45902ef4><h4 class=\"formation-title-new\" data-v-45902ef4>Liturgie</h4><p class=\"formation-description\" data-v-45902ef4> Préparation des activités liturgiques (récollections, messes, prières, célébrations de la parole) et de tout ce qui entre dans ce cadre (lectures, monitions, prière universelles). </p></div></div></div></div><br data-v-45902ef4><br data-v-45902ef4><br data-v-45902ef4>", 4)
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "blog-card style1" }
const _hoisted_8 = {
  class: "blog-info",
  style: {"min-height":"250px"}
}
const _hoisted_9 = { class: "blog-metainfo list-style" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-calendar" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-right-arrow" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.truncatedArticles, (article, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-xl-4 col-lg-6 col-md-6",
          key: index
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "blog-img",
              style: _normalizeStyle({height:'277px', backgroundImage: `url(${_ctx.getUrlApiForFiles(article.urlImage)})`, backgroundSize: 'cover',backgroundPosition: 'center'})
            }, null, 4),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("ul", _hoisted_9, [
                _createElementVNode("li", null, [
                  _hoisted_10,
                  _createTextVNode(),
                  _createVNode(_component_router_link, { to: "#" }, {
                    default: _withCtx(() => [
                      _createTextVNode("L' École d’Initiation Théologique et Pastorale")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", null, [
                  _hoisted_11,
                  _createTextVNode(_toDisplayString(_ctx.format_Date(article.datePublication)), 1)
                ])
              ]),
              _createElementVNode("h3", null, [
                _createVNode(_component_router_link, {
                  to: { name: 'ViewArticlePage', params: { id: article.id } }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(article.titre), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _createVNode(_component_router_link, {
                to: { name: 'ViewArticlePage', params: { id: article.id } },
                class: "link style1"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Lire plus "),
                  _hoisted_12
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}